var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPharmuni = function SvgPharmuni(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "#666664"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.03 3.018V13.51l2.204-2.216v-3.94c.011-1.772-.87-3.353-2.205-4.335ZM12.908 2c-.346 0-.68.036-1 .096v15.557l2.024-2.036V2.096A5.72 5.72 0 0 0 12.909 2ZM9.298 3.413a5.357 5.357 0 0 0-1.728 3.94V22l2.24-2.251V3.006c-.179.12-.345.264-.512.407Z"
  })));
};
export default SvgPharmuni;